import createTrackingClient from '@seek/seek-impression-tracking';
import createLocalEventStore from '@seek/seek-impression-tracking/build/createLocalEventStore';
import { jobTrackingEnabled, jobTrackingUrl } from 'src/config';
import { parse as parseCookies } from 'cookie';
import { logger } from 'src/modules/logger';

const JOB_TRACKING_LOCAL_STORAGE_KEY = 'job-tracking';
const TIMED_REQUEST_INTERVAL_MILLISECONDS = 500;
const sessionId = ENV.CLIENT
  ? parseCookies(document.cookie).JobseekerSessionId
  : null;
const trackingClient =
  ENV.CLIENT && jobTrackingEnabled
    ? createTrackingClient(jobTrackingUrl, {
        store: createLocalEventStore(JOB_TRACKING_LOCAL_STORAGE_KEY),
        params: sessionId ? { sessionId } : null,
        errorLogger: logger.error.bind(logger, 'Impression tracking: '),
        timedRequestInterval: TIMED_REQUEST_INTERVAL_MILLISECONDS
      })
    : {};

// defaults, these are overridden by trackingClient upon initialisation
const {
  forceTrackingRequest = () => Promise.resolve(),
  serializeUnsentImpressions = () => {},
  trackJobClick = () => {},
  trackJobDetailsEmailClicked = () => {},
  trackJobDetailsPhoneClicked = () => {},
  trackJobDetailsUrlClicked = () => {},
  trackRecommendedJobClicked = () => {},
  trackRecommendedJobsViewed = () => {},
  trackNudgeImpression = () => {},
  trackTabImpression = () => {}
} = trackingClient;

export {
  forceTrackingRequest,
  serializeUnsentImpressions,
  trackJobClick,
  trackJobDetailsEmailClicked,
  trackJobDetailsPhoneClicked,
  trackJobDetailsUrlClicked,
  trackRecommendedJobClicked,
  trackRecommendedJobsViewed,
  trackNudgeImpression,
  trackTabImpression
};
